/**
 * searchInterviewQuestions — 面试题推荐工具
 *
 * 根据参数搜索面试题，返回格式化后的 Markdown 链接列表。
 */

import { getInterviewList } from '@/service/interview';

/** 面试题搜索参数 */
export interface InterviewSearchParams {
  pageSize?: number;
  tag?: string;
}

/**
 * 搜索面试题并返回格式化结果
 * @param params 搜索参数
 * @returns Markdown 格式的面试题链接列表
 */
export async function searchInterviewQuestions(params: InterviewSearchParams = {}): Promise<string> {
  try {
    const mergedParams: Record<string, unknown> = { page: 1, ...params };
    const res = await getInterviewList(mergedParams);
    if (res?.success && res.data?.list?.length) {
      const baseUrl = 'https://www.adai.org.cn';
      return res.data.list
        .map(
          (q, i) =>
            `[${q.title}](${baseUrl}/interview-question/article/${q.postsId})`,
        )
        .join('\n');
    }
    return '';
  } catch {
    return '';
  }
}
